import React from 'react';
import DialogPop from '@app/components/DialogPopup/dialogPop';
import { LoadingScreen } from '@app/components/Loading';
import { Outlet } from 'react-router-dom';
const ChildLayout: React.FC = () => {
  return (
    <div className="child-layout">
      <DialogPop />
      <LoadingScreen />
      <div className="header">
        <div>Logo</div>
      </div>
      <div className="main">
        <Outlet />
      </div>
    </div>
  );
};

export default ChildLayout;
